// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 58 ? "quill" : chunkId) + "." + {"58":"448fc2bfa5db2419","297":"95c29e5c382da9f3","913":"5d911f6bd3b45885","959":"f73feb9ed5c2f190"}[chunkId] + ".js";
};